export enum NavigationEvent {
  appNavigated = "[app] navigated",
  shellNavigated = "[shell] navigated",
  appExited = "[app] exited",
  navigateToShellPath = "[app] navigate to shell path",
}
